import BasicRepository from "./basicRepository";
import Client from "../client";
import {TeamResource} from "../resources/teamResource";

class TeamRepository extends BasicRepository<TeamResource, TeamResource> {
    constructor(client: Client) {
        super("Teams", client);
    }
}

export default TeamRepository;


// WEBPACK FOOTER //
// ./node_modules/tslint-loader??ref--1!./app/client/repositories/teamRepository.ts